<script setup lang="ts">
const emits = defineEmits<{
  (e: "reset"): void;
}>();

const modals = useModalStore();

emitter.on("resetAllSettingsConfirmed", () => emits("reset"));
</script>

<template>
  <ToolbarButtonGroup :title="$t('S.LIT_Reset')">
    <ToolbarButton
      icon="fa-light fa-rotate-left"
      :label="$t('SV.LIT_ResetAllSettings')"
      @click="modals.showModal('ConfirmResetSettingsModal')"
    />
  </ToolbarButtonGroup>
</template>

<style scoped lang="postcss"></style>
